// extracted by mini-css-extract-plugin
export default {"onHoldWarning":"OnHoldWarning_onHoldWarning__sY5x2"};